module.exports = require('./dist/sentry/sentry.js');
